import { GET_ROLES_LIST_FAILURE, GET_ROLES_LIST_REQUEST, GET_ROLES_LIST_SUCCESS } from "../constants/roles.constant";
const initialState = {
    loading: false,
    data: [],
    error: '',
};


export const rolesListReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case GET_ROLES_LIST_REQUEST: {
            return {
                ...state,
                loading: true,
                data: [],
            };
        }
        case GET_ROLES_LIST_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        }

        case GET_ROLES_LIST_FAILURE: {
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload,
            };
        }

        default: {
            return {
                ...state
            }
        }
    }
}